import { notifications } from "@mantine/notifications";
import * as Sentry from "@sentry/react";
import { v4 as uuidv4 } from "uuid";
import { CHAT_COMPLETIONS_URL } from "../hooks/useChatCompletion";

export enum FeedbackType {
    POSITIVE = "positive",
    NEGATIVE = "negative",
}

export const sendFeedbackToApi = async (
    apiKey: string | undefined,
    responseId: string,
    feedbackType: FeedbackType,
    feedback: string,
) => {
    const transactionId = uuidv4();

    Sentry.withScope((scope) => {
        scope.setTag("transaction_id", transactionId);
    });

    const response = await fetch(`${CHAT_COMPLETIONS_URL}/v1/feedback/upsert`, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
            "X-Transaction-ID": transactionId,
        },
        method: "POST",
        body: JSON.stringify({
            response_id: responseId,
            feedback_type: feedbackType,
            comments: feedback,
        }),
    });
    // Do the some handling for the response that was being done in the SSE event listeners
    const res = await response.json();
    if (response.status !== 200) {
        notifications.show({
            color: "red",
            title: "Sorry, Feedback failed to be sent!",
            message: res.detail ?? "Please try again later",
        });
    } else {
        notifications.show({
            color: "green",
            title: "Feedback sent successfully!",
            message: "Thanks for sharing, we'll keep improving!",
        });
    }
};
